import { useController } from 'react-hook-form';
import { BorderedRadioList } from 'ui/radioList';
import { RadioListVariantProps } from 'ui/radioList/shortcuts';
import { FieldProps } from './types';

type RadioListFieldProps = FieldProps &
  Omit<RadioListVariantProps, 'onChange' | 'onBlur' | 'value' | 'hasError' | 'variant'>;

export const BorderedRadioListField = ({ name, defaultValue, ...rest }: RadioListFieldProps) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
    defaultValue,
  });

  return <BorderedRadioList {...rest} name={name} value={value} onSelect={onChange} />;
};
